import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './themedInput.module.css';

const ThemedInput = ({ label, placeholder, prefix }) => (
    <Box className={styles.field}>
        <Typography className={styles.label}>{label}</Typography>
        <Box className={styles.control}>
            {prefix && <Box className={styles.prefix}>{prefix}</Box>}
            <Typography className={styles.placeholder}>{placeholder}</Typography>
        </Box>
    </Box>
);

ThemedInput.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    prefix: PropTypes.node,
};

export default ThemedInput;
